import { useCallback, useRef } from "react";

import useFeatureGate from "hooks/useFeatureGate";

import {
  filterDashboardsByFeature,
  filterWidgetsByFeature
} from "./useFeatureGateConfig";

export function useFeatureGatedFilter() {
  const { hasFeature } = useFeatureGate();

  // useFeatureGate() now returns a stable hasFeature reference (memoized in
  // useFeatureFlags/useBetaFeatures), so this ref is no longer required for
  // correctness — kept as a defensive belt-and-suspenders measure so
  // filterDashboards/filterWidgets stay stable even if that memoization
  // guarantee ever regresses upstream.
  const hasFeatureRef = useRef<(name: string) => boolean>(hasFeature);
  hasFeatureRef.current = hasFeature;

  const filterDashboards = useCallback(
    <T extends { featureFlags?: string[] | null }>(dashboards: T[]): T[] => {
      return filterDashboardsByFeature(hasFeatureRef.current, dashboards);
    },
    []
  );

  const filterWidgets = useCallback(
    <T extends { featureFlags?: string[] | null }>(widgets: T[]): T[] => {
      return filterWidgetsByFeature(hasFeatureRef.current, widgets);
    },
    []
  );

  return { filterDashboards, filterWidgets };
}
